// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../Context/CartContext";
// const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
// const BASE_URL = "https://ecom.cyberathon.com/";
// const FREE_SECONDS = 10;

// // ─── Cart Token (guest user) ──────────────────────────────────────────────────
// const getCartToken = () => {
//   let token = localStorage.getItem("cart_token");
//   if (!token) {
//     token = crypto.randomUUID();
//     localStorage.setItem("cart_token", token);
//   }
//   return token;
// };

// // ─── Render HTML safely ───────────────────────────────────────────────────────
// const HtmlContent = ({ html, className = "", maxLines = null }) => {
//   if (!html) return null;
//   const style = maxLines
//     ? {
//         display: "-webkit-box",
//         WebkitLineClamp: maxLines,
//         WebkitBoxOrient: "vertical",
//         overflow: "hidden",
//       }
//     : {};
//   return (
//     <div
//       className={className}
//       style={style}
//       dangerouslySetInnerHTML={{ __html: html }}
//     />
//   );
// };

// // ─── YouTube API Loader ───────────────────────────────────────────────────────
// function loadYouTubeAPI() {
//   if (window.YT && window.YT.Player) return Promise.resolve();
//   if (window.__ytApiPromise) return window.__ytApiPromise;
//   window.__ytApiPromise = new Promise((resolve) => {
//     window.onYouTubeIframeAPIReady = resolve;
//     const tag = document.createElement("script");
//     tag.src = "https://www.youtube.com/iframe_api";
//     document.body.appendChild(tag);
//   });
//   return window.__ytApiPromise;
// }

// function getYouTubeId(embedUrl) {
//   if (!embedUrl) return "";
//   const match = embedUrl.match(/embed\/([^?&]+)/);
//   return match ? match[1] : "";
// }

// function detectVideoType(url) {
//   if (!url || url.trim() === "") return "no-video";
//   const u = url.toLowerCase();
//   if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
//   if (
//     u.endsWith(".mp4") ||
//     u.endsWith(".webm") ||
//     u.endsWith(".ogg") ||
//     u.includes(".mp4?") ||
//     u.includes("gtv-videos-bucket") ||
//     u.includes("commondatastorage.googleapis.com") ||
//     u.includes("archive.org")
//   )
//     return "mp4";
//   if (u.includes("vimeo.com") || u.includes("dailymotion.com")) return "iframe";
//   return "mp4";
// }

// function buildYouTubeEmbedUrl(raw) {
//   try {
//     if (raw.includes("watch?v=")) {
//       const id = new URLSearchParams(new URL(raw).search).get("v");
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("youtu.be/")) {
//       const id = raw.split("youtu.be/")[1].split("?")[0];
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("embed/")) return raw;
//   } catch (e) {}
//   return raw;
// }

// function buildVimeoEmbedUrl(raw) {
//   const match = raw.match(/vimeo\.com\/(\d+)/);
//   if (match) return `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
//   return raw;
// }

// // ─── Add to Cart API (supports guest cart_token) ──────────────────────────────
// async function addToCartApi(prod_id, onSuccess, onError) {
//   const userId = sessionStorage.getItem("userId");
//   const cartToken = !userId ? getCartToken() : null;

//   if (!userId) {
//     // Guest: add using cart_token directly — NO login prompt for courses preview
//     // We still save redirectAfterLogin so if they log in later cart merges
//     sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
//     // Try guest cart insert
//     try {
//       const listRes = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/list_cart",
//         { user_id: null, cart_token: cartToken }
//       );
//       if (listRes.data.status) {
//         const exists = listRes.data.cart_items.find(
//           (i) => String(i.prod_id) === String(prod_id)
//         );
//         if (exists) { onSuccess(); return; }
//       }
//       const res = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//         { user_id: null, prod_id: Number(prod_id), qty: 1, cart_token: cartToken }
//       );
//       if (res.data.status === true) onSuccess();
//       else {
//         // If guest cart not supported by backend → open login modal
//         window.dispatchEvent(new Event("openLoginModal"));
//       }
//     } catch (e) {
//       console.error(e);
//       window.dispatchEvent(new Event("openLoginModal"));
//     }
//     return;
//   }

//   // Logged-in user
//   try {
//     const listRes = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/list_cart",
//       { user_id: userId, cart_token: null }
//     );
//     if (listRes.data.status) {
//       const exists = listRes.data.cart_items.find(
//         (i) => String(i.prod_id) === String(prod_id)
//       );
//       if (exists) { onSuccess(); return; }
//     }
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//     );
//     if (res.data.status === true) onSuccess();
//     else onError(res.data.message || "Failed to add");
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   }
// }

// // ─── Buy Now API (add to cart then redirect to billing) ──────────────────────
// async function buyNowApi(prod_id, navigate, onError, setBuyLoading) {
//   const userId = sessionStorage.getItem("userId");
//   const cartToken = !userId ? getCartToken() : null;

//   if (!prod_id) {
//     onError("This item is not available for purchase yet.");
//     return;
//   }

//   if (!userId) {
//     // Guest: save intent then open login
//     sessionStorage.setItem("redirectAfterLogin", "/Bill");
//     sessionStorage.setItem("buyNowProdId", String(prod_id));
//     window.dispatchEvent(new Event("openLoginModal"));
//     setBuyLoading(false);
//     return;
//   }

//   try {
//     // Check if already in cart
//     const listRes = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/list_cart",
//       { user_id: userId, cart_token: null }
//     );
//     let cartItem = null;
//     if (listRes.data.status) {
//       cartItem = listRes.data.cart_items.find(
//         (i) => String(i.prod_id) === String(prod_id)
//       );
//     }

//     if (cartItem) {
//       // Already in cart — just go to billing
//       navigate("/Bill");
//     } else {
//       // Insert then go to billing
//       const res = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//         { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//       );
//       if (res.data.status === true) {
//         navigate("/Bill");
//       } else {
//         onError(res.data.message || "Failed to add. Please try again.");
//       }
//     }
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   } finally {
//     setBuyLoading(false);
//   }
// }

// // ─── No-video placeholder ─────────────────────────────────────────────────────
// const NoVideoPlaceholder = () => (
//   <div className="no-video-placeholder">
//     <svg width="38" height="38" viewBox="0 0 24 24" fill="none"
//       stroke="rgba(255,255,255,0.2)" strokeWidth="1.4">
//       <rect x="2" y="2" width="20" height="20" rx="2.5" />
//       <path d="M10 8l6 4-6 4V8z" />
//       <line x1="2" y1="2" x2="22" y2="22" />
//     </svg>
//     <span>No Video Available</span>
//   </div>
// );

// // ─── Video Error Fallback ──────────────────────────────────────────────────────
// const VideoErrorFallback = ({ onRetry }) => (
//   <div className="video-error-fallback">
//     <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
//       stroke="rgba(255,255,255,0.3)" strokeWidth="1.5">
//       <circle cx="12" cy="12" r="10" />
//       <line x1="12" y1="8" x2="12" y2="12" />
//       <line x1="12" y1="16" x2="12.01" y2="16" />
//     </svg>
//     <span>Video could not be loaded</span>
//     {onRetry && (
//       <button className="btn-retry" onClick={onRetry}>Try Again</button>
//     )}
//   </div>
// );

// // ─── Lock Overlay (shown after 10s preview ends) ──────────────────────────────
// const LockOverlay = ({ onReplay, prod_id, isAdded, onAddedChange, navigate }) => {
//   const [loading, setLoading] = useState(false);
//   const [buyLoading, setBuyLoading] = useState(false);

//   const handleCart = async () => {
//     if (isAdded) return;
//     setLoading(true);
//     await addToCartApi(
//       prod_id,
//       () => { onAddedChange(true); setLoading(false); },
//       (msg) => { alert(msg); setLoading(false); }
//     );
//   };

//   const handleBuyNow = async () => {
//     if (!prod_id) return;
//     setBuyLoading(true);
//     await buyNowApi(prod_id, navigate, (msg) => alert(msg), setBuyLoading);
//   };

//   return (
//     <div className="lock-overlay">
//       <div className="lock-pulse-ring" />
//       <div className="lock-icon-wrap">
//         <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff"
//           strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//           <rect x="3" y="11" width="18" height="11" rx="2" />
//           <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//         </svg>
//       </div>
//       <p className="lock-title">Preview Ended</p>
//       <p className="lock-sub">Purchase this course to unlock full access</p>

//       {prod_id && (
//         <div className="lock-action-row">
//           <button
//             className={`btn-lock-cart${isAdded ? " added" : ""}`}
//             onClick={handleCart}
//             disabled={loading || isAdded}
//           >
//             {loading ? (
//               <span className="cs-spinner" />
//             ) : isAdded ? (
//               <>
//                 <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
//                   stroke="currentColor" strokeWidth="2.5">
//                   <polyline points="20 6 9 17 4 12" />
//                 </svg>
//                 Added
//               </>
//             ) : (
//               <>
//                 <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
//                   stroke="currentColor" strokeWidth="2">
//                   <circle cx="9" cy="21" r="1" />
//                   <circle cx="20" cy="21" r="1" />
//                   <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
//                 </svg>
//                 Add to Cart
//               </>
//             )}
//           </button>

//           <button
//             className="btn-lock-buy"
//             onClick={handleBuyNow}
//             disabled={buyLoading}
//           >
//             {buyLoading ? <span className="cs-spinner" /> : "Buy Now"}
//           </button>
//         </div>
//       )}

//       <button className="btn-replay" onClick={onReplay}>
//         <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
//           stroke="currentColor" strokeWidth="2.2">
//           <polyline points="1 4 1 10 7 10" />
//           <path d="M3.51 15a9 9 0 1 0 .49-6" />
//         </svg>
//         Watch Preview Again
//       </button>
//     </div>
//   );
// };

// // ─── Shared Card Body ──────────────────────────────────────────────────────────
// const CardBody = ({
//   video, isPurchased, isAdded, cartLoading, buyLoading,
//   onWatch, onCart, onBuyNow, onNavigate,
// }) => (
//   <div className="card-body-inner">
//     <h3
//       className="card-title"
//       style={{ cursor: onNavigate ? "pointer" : "default" }}
//       onClick={onNavigate}
//     >
//       {video.heading}
//     </h3>

//     {video.description && (
//       <div className="card-desc html-content">
//         <HtmlContent html={video.description} maxLines={3} />
//       </div>
//     )}

//     <div className="price-row">
//       {video.current_price && Number(video.current_price) > 0 ? (
//         <>
//           <span className="price-current">
//             ₹{Number(video.current_price).toLocaleString("en-IN")}
//           </span>
//           {video.old_price && Number(video.old_price) > 0 && (
//             <span className="price-old">
//               ₹{Number(video.old_price).toLocaleString("en-IN")}
//             </span>
//           )}
//         </>
//       ) : (
//         <span className="price-free">Free</span>
//       )}
//     </div>

//     {!video.prod_id ? (
//       <div className="no-prod-tag">
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
//           stroke="currentColor" strokeWidth="2">
//           <circle cx="12" cy="12" r="10" />
//           <line x1="12" y1="8" x2="12" y2="12" />
//           <line x1="12" y1="16" x2="12.01" y2="16" />
//         </svg>
//         Not available for purchase
//       </div>
//     ) : isPurchased ? (
//       <div className="btn-stack">
//         {onWatch && (
//           <button className="btn-watch" onClick={onWatch}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
//               <polygon points="5,3 19,12 5,21" />
//             </svg>
//             Watch Full Course
//           </button>
//         )}
//         {onNavigate && (
//           <button className="btn-view-details" onClick={onNavigate}>
//             View Course Details
//             <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
//               stroke="currentColor" strokeWidth="2.2">
//               <polyline points="9 18 15 12 9 6" />
//             </svg>
//           </button>
//         )}
//       </div>
//     ) : (
//       <div className="btn-stack">
//         <div className="course-action-row">
//           {/* Add to Cart */}
//           <button
//             className={`btn-cart${isAdded ? " added" : ""}`}
//             onClick={onCart}
//             disabled={cartLoading || isAdded}
//           >
//             {cartLoading ? (
//               <span className="cs-spinner" />
//             ) : isAdded ? (
//               <>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
//                   stroke="currentColor" strokeWidth="2.5">
//                   <polyline points="20 6 9 17 4 12" />
//                 </svg>
//                 Added to Cart
//               </>
//             ) : (
//               <>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
//                   stroke="currentColor" strokeWidth="2">
//                   <circle cx="9" cy="21" r="1" />
//                   <circle cx="20" cy="21" r="1" />
//                   <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
//                 </svg>
//                 Add to Cart
//               </>
//             )}
//           </button>

//           {/* Buy Now */}
//           <button
//             className="btn-buy-now"
//             onClick={onBuyNow}
//             disabled={buyLoading}
//           >
//             {buyLoading ? <span className="cs-spinner cs-spinner-dark" /> : "Buy Now"}
//           </button>
//         </div>

//         {onNavigate && (
//           <button className="btn-view-details" onClick={onNavigate}>
//             View Course Details
//             <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
//               stroke="currentColor" strokeWidth="2.2">
//               <polyline points="9 18 15 12 9 6" />
//             </svg>
//           </button>
//         )}
//       </div>
//     )}
//   </div>
// );

// // ─── MP4 Card ──────────────────────────────────────────────────────────────────
// const Mp4VideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
//   const navigate = useNavigate();
//   const [phase, setPhase] = useState("idle");
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const [buyLoading, setBuyLoading] = useState(false);
//   const videoRef = useRef(null);
//   const timerRef = useRef(null);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handlePlay = () => setPhase("playing");

//   useEffect(() => {
//     if (phase !== "playing") return;
//     const vid = videoRef.current;
//     if (!vid || isPurchased) return;
//     const onPlay = () => {
//       timerRef.current = setTimeout(() => {
//         vid.pause();
//         setPhase("locked");
//       }, FREE_SECONDS * 1000);
//     };
//     vid.addEventListener("play", onPlay);
//     return () => {
//       vid.removeEventListener("play", onPlay);
//       clearTimeout(timerRef.current);
//     };
//   }, [phase, isPurchased]);

//   const handleReplay = () => { clearTimeout(timerRef.current); setPhase("idle"); };

//   const handleAddedChange = (val) => {
//     setIsAdded(val);
//     if (onCartChange) onCartChange(video.prod_id, val);
//   };

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   const handleBuyNow = async () => {
//     setBuyLoading(true);
//     await buyNowApi(video.prod_id, navigate, (msg) => alert(msg), setBuyLoading);
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased
//           ? <span className="badge badge-purchased">
//               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//               Purchased
//             </span>
//           : <span className="badge badge-preview">
//               <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//               {FREE_SECONDS}s Free Preview
//             </span>
//         }

//         {phase === "idle" && (
//           <>
//             <video
//               src={`${video.embedUrl}#t=0.5`}
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//               preload="metadata" muted playsInline
//             />
//             <div className="play-overlay">
//               <button className="play-btn" onClick={handlePlay}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <polygon points="5,3 19,12 5,21" />
//                 </svg>
//               </button>
//             </div>
//           </>
//         )}

//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <video
//               ref={videoRef}
//               src={video.embedUrl}
//               controls={isPurchased}
//               autoPlay playsInline
//               onError={() => setPhase("error")}
//               style={{ width: "100%", height: "100%", objectFit: "cover" }}
//             />
//             {phase === "locked" && (
//               <LockOverlay
//                 onReplay={handleReplay}
//                 prod_id={video.prod_id}
//                 isAdded={isAdded}
//                 onAddedChange={handleAddedChange}
//                 navigate={navigate}
//               />
//             )}
//           </>
//         )}

//         {phase === "error" && <VideoErrorFallback onRetry={() => setPhase("idle")} />}
//       </div>

//       <CardBody
//         video={video}
//         isPurchased={isPurchased}
//         isAdded={isAdded}
//         cartLoading={cartLoading}
//         buyLoading={buyLoading}
//         onWatch={handlePlay}
//         onCart={handleCartClick}
//         onBuyNow={handleBuyNow}
//         onNavigate={onNavigate}
//       />
//     </div>
//   );
// };

// // ─── YouTube Card ──────────────────────────────────────────────────────────────
// const YoutubeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
//   const navigate = useNavigate();
//   const [phase, setPhase] = useState("thumbnail");
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const [buyLoading, setBuyLoading] = useState(false);
//   const timerRef = useRef(null);
//   const playerRef = useRef(null);
//   const divId = `yt-player-${video.prod_id}`;
//   const videoId = getYouTubeId(video.embedUrl);
//   const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handlePlay = async () => {
//     setPhase("playing");
//     await loadYouTubeAPI();
//     setTimeout(() => {
//       playerRef.current = new window.YT.Player(divId, {
//         events: {
//           onReady: (e) => {
//             e.target.playVideo();
//             if (!isPurchased) {
//               timerRef.current = setTimeout(() => {
//                 e.target.pauseVideo();
//                 setPhase("locked");
//               }, FREE_SECONDS * 1000);
//             }
//           },
//         },
//       });
//     }, 300);
//   };

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) {
//       try { playerRef.current.destroy(); } catch (e) {}
//       playerRef.current = null;
//     }
//     setPhase("thumbnail");
//   };

//   useEffect(() => () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) {
//       try { playerRef.current.destroy(); } catch (e) {}
//     }
//   }, []);

//   const handleAddedChange = (val) => {
//     setIsAdded(val);
//     if (onCartChange) onCartChange(video.prod_id, val);
//   };

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   const handleBuyNow = async () => {
//     setBuyLoading(true);
//     await buyNowApi(video.prod_id, navigate, (msg) => alert(msg), setBuyLoading);
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased
//           ? <span className="badge badge-purchased">
//               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//               Purchased
//             </span>
//           : <span className="badge badge-preview">
//               <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//               {FREE_SECONDS}s Free Preview
//             </span>
//         }

//         {phase === "thumbnail" && (
//           <>
//             {thumbUrl
//               ? <img src={thumbUrl} alt={video.heading}
//                   style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//               : <div style={{ width: "100%", height: "100%", background: "#0d1117" }} />
//             }
//             <div className="play-overlay">
//               <button className="play-btn" onClick={handlePlay}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <polygon points="5,3 19,12 5,21" />
//                 </svg>
//               </button>
//             </div>
//           </>
//         )}

//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <iframe
//               id={divId}
//               src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
//               title={video.heading}
//               allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none" }}
//             />
//             {phase === "locked" && (
//               <LockOverlay
//                 onReplay={handleReplay}
//                 prod_id={video.prod_id}
//                 isAdded={isAdded}
//                 onAddedChange={handleAddedChange}
//                 navigate={navigate}
//               />
//             )}
//           </>
//         )}
//       </div>

//       <CardBody
//         video={video}
//         isPurchased={isPurchased}
//         isAdded={isAdded}
//         cartLoading={cartLoading}
//         buyLoading={buyLoading}
//         onWatch={handlePlay}
//         onCart={handleCartClick}
//         onBuyNow={handleBuyNow}
//         onNavigate={onNavigate}
//       />
//     </div>
//   );
// };

// // ─── IFrame Card ───────────────────────────────────────────────────────────────
// const IframeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
//   const navigate = useNavigate();
//   const [phase, setPhase] = useState("thumbnail");
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const [buyLoading, setBuyLoading] = useState(false);
//   const timerRef = useRef(null);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handlePlay = () => {
//     setPhase("playing");
//     if (!isPurchased) {
//       timerRef.current = setTimeout(() => setPhase("locked"), FREE_SECONDS * 1000);
//     }
//   };

//   const handleReplay = () => { clearTimeout(timerRef.current); setPhase("thumbnail"); };
//   useEffect(() => () => clearTimeout(timerRef.current), []);

//   const handleAddedChange = (val) => {
//     setIsAdded(val);
//     if (onCartChange) onCartChange(video.prod_id, val);
//   };

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   const handleBuyNow = async () => {
//     setBuyLoading(true);
//     await buyNowApi(video.prod_id, navigate, (msg) => alert(msg), setBuyLoading);
//   };

//   const iframeSrc = video.embedUrl.includes("vimeo")
//     ? buildVimeoEmbedUrl(video.embedUrl)
//     : video.embedUrl;

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased
//           ? <span className="badge badge-purchased">
//               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//               Purchased
//             </span>
//           : <span className="badge badge-preview">
//               <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//               {FREE_SECONDS}s Free Preview
//             </span>
//         }

//         {phase === "thumbnail" && (
//           <div className="play-overlay" style={{ background: "rgba(0,0,0,0.55)" }}>
//             <button className="play-btn" onClick={handlePlay}>
//               <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                 <polygon points="5,3 19,12 5,21" />
//               </svg>
//             </button>
//           </div>
//         )}

//         {(phase === "playing" || phase === "locked") && (
//           <>
//             <iframe
//               src={iframeSrc}
//               title={video.heading}
//               allow="autoplay; fullscreen"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none" }}
//             />
//             {phase === "locked" && (
//               <LockOverlay
//                 onReplay={handleReplay}
//                 prod_id={video.prod_id}
//                 isAdded={isAdded}
//                 onAddedChange={handleAddedChange}
//                 navigate={navigate}
//               />
//             )}
//           </>
//         )}
//       </div>

//       <CardBody
//         video={video}
//         isPurchased={isPurchased}
//         isAdded={isAdded}
//         cartLoading={cartLoading}
//         buyLoading={buyLoading}
//         onWatch={handlePlay}
//         onCart={handleCartClick}
//         onBuyNow={handleBuyNow}
//         onNavigate={onNavigate}
//       />
//     </div>
//   );
// };

// // ─── No Video Card ─────────────────────────────────────────────────────────────
// const NoVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
//   const navigate = useNavigate();
//   const [isAdded, setIsAdded] = useState(initAdded);
//   const [cartLoading, setCartLoading] = useState(false);
//   const [buyLoading, setBuyLoading] = useState(false);

//   useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

//   const handleCartClick = async () => {
//     if (isAdded) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   const handleBuyNow = async () => {
//     setBuyLoading(true);
//     await buyNowApi(video.prod_id, navigate, (msg) => alert(msg), setBuyLoading);
//   };

//   return (
//     <div className="course-card">
//       <div className="video-area">
//         {isPurchased && (
//           <span className="badge badge-purchased">
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
//               <polyline points="20 6 9 17 4 12" />
//             </svg>
//             Purchased
//           </span>
//         )}
//         <NoVideoPlaceholder />
//       </div>

//       <CardBody
//         video={video}
//         isPurchased={isPurchased}
//         isAdded={isAdded}
//         cartLoading={cartLoading}
//         buyLoading={buyLoading}
//         onWatch={null}
//         onCart={handleCartClick}
//         onBuyNow={handleBuyNow}
//         onNavigate={onNavigate}
//       />
//     </div>
//   );
// };

// // ─── MAIN COMPONENT ────────────────────────────────────────────────────────────
// const CourseSection3 = () => {
//     const { setCartCount } = useCart();
//   const navigate = useNavigate();
//   const [videos, setVideos] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
//   const [cartProdIds, setCartProdIds] = useState(new Set());

//   // ── Load products ──
//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         if (!res.data?.status) { setError("No products found"); return; }

//         const products = Array.isArray(res.data.products) ? res.data.products : [];

//         const list = products
//           .filter((p) => p.product_type && p.product_type.toLowerCase() === "coursesection")
//           .map((p) => {
//             let rawUrl = p.video || p.video_url || p.product_video || "";
//             if (rawUrl && !rawUrl.startsWith("http")) rawUrl = BASE_URL + rawUrl;
//             const type = detectVideoType(rawUrl);
//             let embedUrl = rawUrl;
//             if (type === "youtube") embedUrl = buildYouTubeEmbedUrl(rawUrl);
//             return {
//               id: p.id || p.ref_id,
//               prod_id: p.prod_id,
//               heading: p.heading || p.product_name || p.title || "Untitled Course",
//               description: p.description || "",
//               details: p.details || "",
//               current_price: p.current_price || 0,
//               old_price: p.old_price || 0,
//               embedUrl,
//               type,
//             };
//           });

//         setVideos(list);
//       } catch (e) {
//         console.error("API Error:", e);
//         setError("Failed to fetch products");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   // ── Load cart & purchased state ──
//   useEffect(() => {
//     const init = async () => {
//       const userId = sessionStorage.getItem("userId");
//       // For guest: use cart_token; for logged-in: use userId
//       const cartToken = localStorage.getItem("cart_token");

//       // Load cart items (works for both guest & logged-in)
//       if (userId || cartToken) {
//         try {
//           const res = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/list_cart",
//             {
//               user_id: userId || null,
//               cart_token: userId ? null : cartToken,
//             }
//           );
//           if (res.data.status) {
//             setCartProdIds(
//               new Set(res.data.cart_items.map((i) => String(i.prod_id)))
//             );
//           }
//         } catch (e) { console.error(e); }
//       }

//       // Load purchased items (only for logged-in users)
//       if (userId) {
//         try {
//           const res = await axios.post(
//             "https://ecom.cyberathon.com/index.php/Api/list_new_order",
//             { user_id: parseInt(userId) }
//           );
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             const ids = new Set();
//             res.data.orders.forEach((order) => {
//               if (!Array.isArray(order.items)) return;
//               order.items.forEach((item) => {
//                 if (!item.prod_id) return;
//                 if (
//                   item.access === "unlocked" ||
//                   order.purchase_status === "yes" ||
//                   order.payment_status === "Paid" ||
//                   order.payment_status === "paid" ||
//                   order.order_status === "Delivered" ||
//                   order.order_status === "Completed"
//                 ) {
//                   ids.add(String(item.prod_id));
//                 }
//               });
//             });
//             setPurchasedProdIds(ids);
//           }
//         } catch (e) { console.error(e); }
//       }
//     };
//     init();

//     // Re-init on login event (so cart merges after login)
//     const onLogin = () => init();
//     window.addEventListener("userLoggedIn", onLogin);
//     return () => window.removeEventListener("userLoggedIn", onLogin);
//   }, []);

// //   const handleCartChange = (prod_id, added) => {
// //     setCartProdIds((prev) => {
// //       const next = new Set(prev);
// //       if (added) next.add(String(prod_id));
// //       else next.delete(String(prod_id));
// //       return next;
// //     });
// //   };

// const handleCartChange = (prod_id, added) => {
//   setCartProdIds((prev) => {
//     const next = new Set(prev);

//     if (added) {
//       if (!next.has(String(prod_id))) {
//         next.add(String(prod_id));
//         setCartCount((c) => c + 1); // ✅ increment count
//       }
//     } else {
//       if (next.has(String(prod_id))) {
//         next.delete(String(prod_id));
//         setCartCount((c) => Math.max(0, c - 1)); // optional decrement
//       }
//     }

//     return next;
//   });
// };

//   const renderCard = (v) => {
//     const strId = String(v.prod_id);
//     const isPurchased = purchasedProdIds.has(strId);
//     const isAdded = cartProdIds.has(strId);
//     const props = {
//       key: v.prod_id,
//       video: v,
//       isPurchased,
//       isAdded,
//       onCartChange: handleCartChange,
//       onNavigate: () => navigate(`/coursesectiondetail/${v.prod_id}`),
//     };

//     switch (v.type) {
//       case "youtube":  return <YoutubeVideoCard {...props} />;
//       case "mp4":      return <Mp4VideoCard {...props} />;
//       case "iframe":   return <IframeVideoCard {...props} />;
//       case "no-video": return <NoVideoCard {...props} />;
//       default:         return <Mp4VideoCard {...props} />;
//     }
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

//         :root {
//           --teal: #0ecfce;
//           --teal-dark: #0ab5b4;
//           --green: #22c55e;
//           --green-dark: #16a34a;
//           --amber: #f59e0b;
//           --amber-dark: #d97706;
//           --card-bg: #ffffff;
//           --card-border: #e5f0f0;
//           --card-hover-border: #0ecfce;
//           --text-primary: #0f172a;
//           --text-secondary: #475569;
//           --text-muted: #94a3b8;
//           --surface: #f7fffe;
//         }

//         .cs-root {
//           background: var(--surface);
//           min-height: 60vh;
//           padding: 64px 0 80px;
//           font-family: 'DM Sans', sans-serif;
//         }

//         /* ── Grid ── */
//         .cs-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
//           gap: 24px;
//           padding: 0 24px;
//           max-width: 1240px;
//           margin: 0 auto;
//         }

//         /* ── Card ── */
//         .course-card {
//           background: var(--card-bg);
//           border: 1.5px solid var(--card-border);
//           border-radius: 20px;
//           overflow: hidden;
//           display: flex;
//           flex-direction: column;
//           transition: transform 0.28s cubic-bezier(.22,.68,0,1.2),
//                       box-shadow 0.28s ease,
//                       border-color 0.2s ease;
//           animation: csCardIn 0.45s ease both;
//           position: relative;
//         }
//         .course-card:hover {
//           transform: translateY(-7px);
//           box-shadow: 0 20px 52px rgba(14,207,206,0.12), 0 4px 16px rgba(0,0,0,0.05);
//           border-color: var(--card-hover-border);
//         }
//         @keyframes csCardIn {
//           from { opacity: 0; transform: translateY(22px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }

//         /* ── Video Area ── */
//         .video-area {
//           position: relative;
//           width: 100%;
//           height: 205px;
//           background: #0d1117;
//           overflow: hidden;
//           flex-shrink: 0;
//         }
//         .video-area img,
//         .video-area video,
//         .video-area iframe {
//           width: 100%; height: 100%; object-fit: cover; display: block;
//         }

//         .no-video-placeholder {
//           width: 100%; height: 100%;
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           gap: 10px; background: #0d1117;
//         }
//         .no-video-placeholder span {
//           font-size: 12px; color: rgba(255,255,255,0.2);
//           font-family: 'DM Sans', sans-serif;
//         }

//         .video-error-fallback {
//           width: 100%; height: 100%;
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           gap: 10px; background: #0d1117;
//           padding: 20px; text-align: center;
//         }
//         .video-error-fallback span {
//           font-size: 12px; color: rgba(255,255,255,0.25);
//           font-family: 'DM Sans', sans-serif;
//         }
//         .btn-retry {
//           background: rgba(14,207,206,0.12); color: var(--teal);
//           border: 1px solid rgba(14,207,206,0.3); border-radius: 8px;
//           padding: 5px 14px; font-size: 11.5px; font-weight: 600;
//           cursor: pointer; font-family: 'DM Sans', sans-serif;
//           transition: background 0.2s;
//         }
//         .btn-retry:hover { background: rgba(14,207,206,0.2); }

//         /* ── Play overlay ── */
//         .play-overlay {
//           position: absolute; inset: 0;
//           background: rgba(0,0,0,0.28);
//           display: flex; align-items: center; justify-content: center;
//           z-index: 4; transition: background 0.2s; cursor: pointer;
//         }
//         .play-overlay:hover { background: rgba(0,0,0,0.4); }
//         .play-btn {
//           width: 56px; height: 56px; border-radius: 50%;
//           background: var(--teal); border: 3px solid rgba(255,255,255,0.25);
//           display: flex; align-items: center; justify-content: center;
//           cursor: pointer;
//           transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s;
//           box-shadow: 0 4px 24px rgba(14,207,206,0.4);
//         }
//         .play-btn:hover { transform: scale(1.12); background: var(--teal-dark); }
//         .play-btn svg { margin-left: 3px; }

//         /* ── Badges ── */
//         .badge {
//           position: absolute; top: 12px; left: 12px;
//           display: inline-flex; align-items: center; gap: 5px;
//           font-size: 11px; font-weight: 700; padding: 4px 6px;
//           border-radius: 100px; z-index: 5; letter-spacing: 0.2px;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           backdrop-filter: blur(8px);
//         }
//         .badge-preview {
//           background: rgba(14,207,206,0.18); color: #fff;
//           border: 1px solid rgba(14,207,206,0.4);
//         }
//         .badge-purchased {
//           background: rgba(34,197,94,0.18); color: #fff;
//           border: 1px solid rgba(34,197,94,0.4);
//         }

//         /* ── Lock Overlay ── */
//         .lock-overlay {
//           position: absolute; inset: 0;
//           background: rgba(8,12,20,0.93); backdrop-filter: blur(6px);
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           z-index: 10; padding: 24px 20px; text-align: center; gap: 9px;
//           animation: csLockIn 0.22s ease;
//         }
//         @keyframes csLockIn {
//           from { opacity: 0; transform: scale(0.97); }
//           to   { opacity: 1; transform: scale(1); }
//         }
//         .lock-pulse-ring {
//           position: absolute; width: 90px; height: 90px; border-radius: 50%;
//           border: 1.5px solid rgba(14,207,206,0.22);
//           animation: lockPulse 2s ease-in-out infinite;
//           pointer-events: none;
//         }
//         @keyframes lockPulse {
//           0%, 100% { transform: scale(1); opacity: 0.5; }
//           50% { transform: scale(1.35); opacity: 0; }
//         }
//         .lock-icon-wrap {
//           width: 58px; height: 58px; border-radius: 50%;
//           background: rgba(14,207,206,0.1); border: 1.5px solid rgba(14,207,206,0.3);
//           display: flex; align-items: center; justify-content: center;
//           position: relative; z-index: 1;
//         }
//         .lock-title {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 15px; font-weight: 800; color: #f1f5f9; margin: 2px 0 0;
//         }
//         .lock-sub {
//           font-size: 12px; color: #64748b; margin: 0;
//           line-height: 1.55; max-width: 200px;
//         }

//         /* Lock overlay action buttons */
//         .lock-action-row {
//           display: flex; gap: 8px; width: 100%; max-width: 220px;
//         }
//         .btn-lock-cart {
//           flex: 1; background: var(--teal); color: #fff;
//           border: none; border-radius: 10px;
//           padding: 9px 10px; font-size: 12px; font-weight: 700; cursor: pointer;
//           display: flex; align-items: center; justify-content: center; gap: 5px;
//           transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-lock-cart:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
//         .btn-lock-cart.added { background: #24aeb1; cursor: default; }
//         .btn-lock-cart:disabled { opacity: 0.7; }

//         .btn-lock-buy {
//           flex: 1; background:#24aeb1; color: #fff;
//           border: none; border-radius: 10px;
//           padding: 9px 10px; font-size: 12px; font-weight: 700; cursor: pointer;
//           display: flex; align-items: center; justify-content: center;
//           transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-lock-buy:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
//         .btn-lock-buy:disabled { opacity: 0.7; cursor: not-allowed; }

//         .btn-replay {
//           background: transparent; color: #475569;
//           border: 1px solid #2d3748; border-radius: 8px;
//           padding: 6px 14px; font-size: 11.5px; font-weight: 600;
//           cursor: pointer; display: flex; align-items: center; gap: 5px;
//           transition: color 0.2s, border-color 0.2s;
//           font-family: 'DM Sans', sans-serif;
//         }
//         .btn-replay:hover { color: #94a3b8; border-color: #475569; }

//         /* ── Card Body ── */
//         .card-body-inner {
//           padding: 18px 20px 20px;
//           display: flex; flex-direction: column;
//           flex: 1; gap: 10px;
//         }
//         .card-title {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 15.5px; font-weight: 700; color: var(--text-primary);
//           margin: 0; line-height: 1.4; letter-spacing: -0.2px;
//           transition: color 0.15s;
//         }
//         .card-title:hover { color: var(--teal); }

//         /* HTML content inside description */
//         .html-content ul, .html-content ol { padding-left: 20px; margin: 4px 0; }
//         .html-content ul li, .html-content ol li {
//           color: var(--text-secondary); font-size: 13px;
//           margin-bottom: 3px; line-height: 1.6; list-style-type: disc;
//         }
//         .html-content ol li { list-style-type: decimal; }
//         .html-content p { margin: 0 0 4px; color: var(--text-secondary); font-size: 13px; line-height: 1.65; }
//         .html-content strong { color: var(--text-primary); }
//         .html-content a { color: var(--teal); text-decoration: none; }
//         .card-desc { font-size: 13px; color: var(--text-secondary); line-height: 1.65; }

//         /* ── Price ── */
//         .price-row { display: flex; align-items: baseline; gap: 10px; margin-top: 2px; }
//         .price-current {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 21px; font-weight: 800;
//           color: var(--green); letter-spacing: -0.5px;
//         }
//         .price-old {
//           font-size: 13.5px; color: var(--text-muted);
//           text-decoration: line-through; font-weight: 500;
//         }
//         .price-free {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           font-size: 16px; font-weight: 700; color: var(--teal);
//         }

//         .no-prod-tag {
//           display: inline-flex; align-items: center; gap: 5px;
//           color: var(--text-muted); font-size: 12px; font-weight: 500;
//           padding: 8px 12px; border-radius: 8px;
//           background: #f8fafc; border: 1px dashed #e2e8f0;
//           font-family: 'DM Sans', sans-serif; margin-top: auto;
//         }

//         /* ── Button stack ── */
//         .btn-stack {
//           display: flex; flex-direction: column;
//           gap: 8px; margin-top: auto;
//         }

//         /* Add to Cart + Buy Now side by side */
//         .course-action-row {
//           display: flex; gap: 8px;
//         }

//         /* Add to Cart */
//         .btn-cart {
//           flex: 1;
//           padding: 11px 0; border-radius: 12px;
//           border: 1.5px solid var(--teal);
//           font-size: 13px; font-weight: 700;
//           cursor: pointer; background: linear-gradient(135deg, #24aeb1, #058587); color: white;
//           display: flex; align-items: center; justify-content: center;
//           gap: 6px; letter-spacing: 0.1px;
//           transition: background 0.2s, color 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           min-width: 0;
//         }
//         .btn-cart:hover:not(:disabled):not(.added) {
//           background: #24aeb1; color: #fff; transform: translateY(-1px);
//         }
//         .btn-cart.added {
//           background: #24aeb1; border-color: #24aeb1;
//           color: white; cursor: default;
//         }
//         .btn-cart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

//         /* Buy Now */
//         .btn-buy-now {
//           flex: 1;
//           padding: 11px 0; border-radius: 12px;
//           border: none;
//           font-size: 13px; font-weight: 700;
//           cursor: pointer;
//           background: linear-gradient(135deg, #24aeb1, #058587);
//           color: #fff;
//           display: flex; align-items: center; justify-content: center;
//           gap: 6px;
//           transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           box-shadow: 0 2px 12px rgba(19, 170, 176, 0.3);
//           min-width: 0;
//         }
//         .btn-buy-now:hover:not(:disabled) {
//           opacity: 0.92; transform: translateY(-1px);
//           box-shadow: 0 4px 18px rgba(10, 179, 182, 0.4);
//         }
//         .btn-buy-now:disabled { opacity: 0.65; cursor: not-allowed; }

//         /* Watch full course */
//         .btn-watch {
//           padding: 12px 0; border-radius: 12px; border: none;
//           font-size: 13.5px; font-weight: 700; cursor: pointer;
//           background: linear-gradient(135deg, #22c55e, #16a34a); color: #fff;
//           width: 100%; display: flex; align-items: center; justify-content: center;
//           gap: 7px; transition: opacity 0.2s, transform 0.15s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-watch:hover { opacity: 0.9; transform: translateY(-1px); }

//         /* View details */
//         .btn-view-details {
//           padding: 9px 0; border-radius: 10px;
//           border: 1px solid #24aeb1;
//           font-size: 13px; font-weight: 600;
//           cursor: pointer; background: #f8fffe; color: var(--teal);
//           width: 100%; display: flex; align-items: center; justify-content: center;
//           gap: 5px; transition: background 0.2s, border-color 0.2s;
//           font-family: 'Plus Jakarta Sans', sans-serif;
//         }
//         .btn-view-details:hover {
//           background: rgba(14,207,206,0.06); border-color: var(--teal);
//         }

//         /* ── Spinners ── */
//         .cs-spinner {
//           display: inline-block; width: 15px; height: 15px;
//           border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
//           border-radius: 50%; animation: csSpin 0.7s linear infinite;
//         }
//         .cs-spinner-dark {
//           border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
//         }
//         @keyframes csSpin { to { transform: rotate(360deg); } }

//         /* ── Skeleton ── */
//         .cs-skeleton-card {
//           background: white; border-radius: 20px;
//           overflow: hidden; border: 1.5px solid #f1f5f9;
//         }
//         .cs-skeleton {
//           background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%);
//           background-size: 200% 100%;
//           animation: csSkeleton 1.5s ease-in-out infinite;
//           border-radius: 6px;
//         }
//         @keyframes csSkeleton {
//           0% { background-position: -200% 0; }
//           100% { background-position: 200% 0; }
//         }

//         @media (max-width: 600px) {
//           .cs-grid { padding: 0 12px; gap: 16px; }
//           .course-action-row { flex-direction: column; gap: 8px; }
//           .btn-cart, .btn-buy-now { flex: none; width: 100%; }
//         }
//       `}</style>

//       <div className="cs-root">
//         <div className="container-fluid px-0">
//           <h1 className="text-center fw-bold text-bold pb-5">Our Courses</h1>

//           {loading && (
//             <div className="cs-grid">
//               {[1, 2, 3].map((n) => (
//                 <div key={n} className="cs-skeleton-card">
//                   <div className="cs-skeleton" style={{ height: 205, borderRadius: 0 }} />
//                   <div style={{ padding: "18px 20px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
//                     <div className="cs-skeleton" style={{ height: 18, width: "85%" }} />
//                     <div className="cs-skeleton" style={{ height: 13, width: "70%" }} />
//                     <div className="cs-skeleton" style={{ height: 13, width: "55%" }} />
//                     <div className="cs-skeleton" style={{ height: 28, width: "40%", marginTop: 4 }} />
//                     <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
//                       <div className="cs-skeleton" style={{ height: 44, flex: 1, borderRadius: 12 }} />
//                       <div className="cs-skeleton" style={{ height: 44, flex: 1, borderRadius: 12 }} />
//                     </div>
//                     <div className="cs-skeleton" style={{ height: 38, borderRadius: 10 }} />
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {error && (
//             <p style={{ textAlign: "center", color: "#ef4444", padding: 40 }}>{error}</p>
//           )}

//           {!loading && !error && videos.length === 0 && (
//             <p style={{ textAlign: "center", color: "#94a3b8", padding: 40 }}>No courses found.</p>
//           )}

//           {!loading && !error && (
//             <div className="cs-grid">
//               {videos.map((v) => renderCard(v))}
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default CourseSection3;



import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../../Context/CartContext";
import SEO from "../../SEO";
const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
const BASE_URL = "https://ecom.cyberathon.com/";
const FREE_SECONDS = 10;

// ─── Cart Token (guest user) ──────────────────────────────────────────────────
const getCartToken = () => {
  let token = localStorage.getItem("cart_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("cart_token", token);
  }
  return token;
};

// ─── Render HTML safely ───────────────────────────────────────────────────────
const HtmlContent = ({ html, className = "", maxLines = null }) => {
  if (!html) return null;
  const style = maxLines
    ? {
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
      }
    : {};
  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

// ─── YouTube API Loader ───────────────────────────────────────────────────────
function loadYouTubeAPI() {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (window.__ytApiPromise) return window.__ytApiPromise;
  window.__ytApiPromise = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = resolve;
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
  });
  return window.__ytApiPromise;
}

function getYouTubeId(embedUrl) {
  if (!embedUrl) return "";
  const match = embedUrl.match(/embed\/([^?&]+)/);
  return match ? match[1] : "";
}

function detectVideoType(url) {
  if (!url || url.trim() === "") return "no-video";
  const u = url.toLowerCase();
  if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
  if (
    u.endsWith(".mp4") ||
    u.endsWith(".webm") ||
    u.endsWith(".ogg") ||
    u.includes(".mp4?") ||
    u.includes("gtv-videos-bucket") ||
    u.includes("commondatastorage.googleapis.com") ||
    u.includes("archive.org")
  )
    return "mp4";
  if (u.includes("vimeo.com") || u.includes("dailymotion.com")) return "iframe";
  return "mp4";
}

function buildYouTubeEmbedUrl(raw) {
  try {
    if (raw.includes("watch?v=")) {
      const id = new URLSearchParams(new URL(raw).search).get("v");
      return `https://www.youtube.com/embed/${id}`;
    }
    if (raw.includes("youtu.be/")) {
      const id = raw.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }
    if (raw.includes("embed/")) return raw;
  } catch (e) {}
  return raw;
}

function buildVimeoEmbedUrl(raw) {
  const match = raw.match(/vimeo\.com\/(\d+)/);
  if (match) return `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
  return raw;
}

// ─── Add to Cart API (supports guest cart_token) ──────────────────────────────
async function addToCartApi(prod_id, onSuccess, onError) {
  const userId = sessionStorage.getItem("userId");
  const cartToken = !userId ? getCartToken() : null;

  if (!userId) {
    sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
    try {
      const listRes = await axios.post(
        "https://ecom.cyberathon.com/index.php/Api/list_cart",
        { user_id: null, cart_token: cartToken }
      );
      if (listRes.data.status) {
        const exists = listRes.data.cart_items.find(
          (i) => String(i.prod_id) === String(prod_id)
        );
        if (exists) { onSuccess(); return; }
      }
      const res = await axios.post(
        "https://ecom.cyberathon.com/index.php/Api/insert_cart",
        { user_id: null, prod_id: Number(prod_id), qty: 1, cart_token: cartToken }
      );
      if (res.data.status === true) onSuccess();
      else {
        window.dispatchEvent(new Event("openLoginModal"));
      }
    } catch (e) {
      console.error(e);
      window.dispatchEvent(new Event("openLoginModal"));
    }
    return;
  }

  // Logged-in user
  try {
    const listRes = await axios.post(
      "https://ecom.cyberathon.com/index.php/Api/list_cart",
      { user_id: userId, cart_token: null }
    );
    if (listRes.data.status) {
      const exists = listRes.data.cart_items.find(
        (i) => String(i.prod_id) === String(prod_id)
      );
      if (exists) { onSuccess(); return; }
    }
    const res = await axios.post(
      "https://ecom.cyberathon.com/index.php/Api/insert_cart",
      { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
    );
    if (res.data.status === true) onSuccess();
    else onError(res.data.message || "Failed to add");
  } catch (e) {
    console.error(e);
    onError("Something went wrong");
  }
}

// ─── ✅ UPDATED: Buy Now (no cart insert, direct navigate with product data) ──
async function buyNowApi(video, navigate, onError, setBuyLoading) {
  const userId = sessionStorage.getItem("userId");

  if (!video?.prod_id) {
    onError("This item is not available for purchase yet.");
    return;
  }

  // if (!userId) {
  //   sessionStorage.setItem("redirectAfterLogin", "/Bill");
  //   window.dispatchEvent(new Event("openLoginModal"));
  //   setBuyLoading(false);
  //   return;
  // }
  if (!userId) {

  const buyNowProduct = {
    prod_id: video.prod_id,
    Product_name: video.heading || "",
    current_price: video.current_price || 0,
    qty: 1,
    size: "",
    Product_image: "",
    product_type:"coursesection",
  };

  // 🔥 product save karo
  sessionStorage.setItem(
    "buyNowProduct",
    JSON.stringify(buyNowProduct)
  );

  sessionStorage.setItem(
    "redirectAfterLogin",
    "/Bill"
  );

  // 🔥 login modal open
  window.dispatchEvent(
    new Event("openLoginModal")
  );

  setBuyLoading(false);
  return;
}

  const buyNowProduct = {
    prod_id: video.prod_id,
    Product_name: video.heading || "",
    current_price: video.current_price || 0,
    qty: 1,
    size: "",
    Product_image: ""
  };

  navigate("/Bill", {
    state: {
      buyNow: true,
      product: buyNowProduct
    }
  });

  setBuyLoading(false);
}

// ─── No-video placeholder ─────────────────────────────────────────────────────
const NoVideoPlaceholder = () => (
  <div className="no-video-placeholder">
    <svg width="38" height="38" viewBox="0 0 24 24" fill="none"
      stroke="rgba(255,255,255,0.2)" strokeWidth="1.4">
      <rect x="2" y="2" width="20" height="20" rx="2.5" />
      <path d="M10 8l6 4-6 4V8z" />
      <line x1="2" y1="2" x2="22" y2="22" />
    </svg>
    <span>No Video Available</span>
  </div>
);

// ─── Video Error Fallback ──────────────────────────────────────────────────────
const VideoErrorFallback = ({ onRetry }) => (
  <div className="video-error-fallback">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
      stroke="rgba(255,255,255,0.3)" strokeWidth="1.5">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <span>Video could not be loaded</span>
    {onRetry && (
      <button className="btn-retry" onClick={onRetry}>Try Again</button>
    )}
  </div>
);

// ─── Lock Overlay ─────────────────────────────────────────────────────────────
// ✅ UPDATED: uses fakeVideo object for buyNowApi
const LockOverlay = ({ onReplay, prod_id, isAdded, onAddedChange, navigate }) => {
  const [loading, setLoading] = useState(false);
  const [buyLoading, setBuyLoading] = useState(false);

  const handleCart = async () => {
    if (isAdded) return;
    setLoading(true);
    await addToCartApi(
      prod_id,
      () => { onAddedChange(true); setLoading(false); },
      (msg) => { alert(msg); setLoading(false); }
    );
  };

  const handleBuyNow = async () => {
    if (!prod_id) return;
    setBuyLoading(true);
    // ✅ fakeVideo object banao sirf prod_id se
    const fakeVideo = { prod_id, heading: "", current_price: 0 };
    await buyNowApi(fakeVideo, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
  };

  return (
    <div className="lock-overlay">
      <div className="lock-pulse-ring" />
      <div className="lock-icon-wrap">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff"
          strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>
      <p className="lock-title">Preview Ended</p>
      <p className="lock-sub">Purchase this course to unlock full access</p>

      {prod_id && (
        <div className="lock-action-row">
          <button
            className={`btn-lock-cart${isAdded ? " added" : ""}`}
            onClick={handleCart}
            disabled={loading || isAdded}
          >
            {loading ? (
              <span className="cs-spinner" />
            ) : isAdded ? (
              <>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Added
              </>
            ) : (
              <>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2">
                  <circle cx="9" cy="21" r="1" />
                  <circle cx="20" cy="21" r="1" />
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                </svg>
                Add to Cart
              </>
            )}
          </button>

          <button
            className="btn-lock-buy"
            onClick={handleBuyNow}
            disabled={buyLoading}
          >
            {buyLoading ? <span className="cs-spinner" /> : "Buy Now"}
          </button>
        </div>
      )}

      <button className="btn-replay" onClick={onReplay}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.2">
          <polyline points="1 4 1 10 7 10" />
          <path d="M3.51 15a9 9 0 1 0 .49-6" />
        </svg>
        Watch Preview Again
      </button>
    </div>
  );
};

// ─── Shared Card Body ──────────────────────────────────────────────────────────
const CardBody = ({
  video, isPurchased, isAdded, cartLoading, buyLoading,
  onWatch, onCart, onBuyNow, onNavigate,
}) => (
  <div className="card-body-inner">
    <h3
      className="card-title"
      style={{ cursor: onNavigate ? "pointer" : "default" }}
      onClick={onNavigate}
    >
      {video.heading}
    </h3>

    {video.description && (
      <div className="card-desc html-content">
        <HtmlContent html={video.description} maxLines={3} />
      </div>
    )}

    <div className="price-row">
      {video.current_price && Number(video.current_price) > 0 ? (
        <>
          <span className="price-current">
            ₹{Number(video.current_price).toLocaleString("en-IN")}
          </span>
          {video.old_price && Number(video.old_price) > 0 && (
            <span className="price-old">
              ₹{Number(video.old_price).toLocaleString("en-IN")}
            </span>
          )}
        </>
      ) : (
        <span className="price-free">Free</span>
      )}
    </div>

    {!video.prod_id ? (
      <div className="no-prod-tag">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        Not available for purchase
      </div>
    ) : isPurchased ? (
      <div className="btn-stack">
        {onWatch && (
          <button className="btn-watch" onClick={onWatch}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
              <polygon points="5,3 19,12 5,21" />
            </svg>
            Watch Full Course
          </button>
        )}
        {onNavigate && (
          <button className="btn-view-details" onClick={onNavigate}>
            View Course Details
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.2">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        )}
      </div>
    ) : (
      <div className="btn-stack">
        <div className="course-action-row">
          {/* Add to Cart */}
          <button
            className={`btn-cart${isAdded ? " added" : ""}`}
            onClick={onCart}
            disabled={cartLoading || isAdded}
          >
            {cartLoading ? (
              <span className="cs-spinner" />
            ) : isAdded ? (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Added to Cart
              </>
            ) : (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2">
                  <circle cx="9" cy="21" r="1" />
                  <circle cx="20" cy="21" r="1" />
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                </svg>
                Add to Cart
              </>
            )}
          </button>

          {/* Buy Now */}
          <button
            className="btn-buy-now"
            onClick={onBuyNow}
            disabled={buyLoading}
          >
            {buyLoading ? <span className="cs-spinner cs-spinner-dark" /> : "Buy Now"}
          </button>
        </div>

        {onNavigate && (
          <button className="btn-view-details" onClick={onNavigate}>
            View Course Details
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.2">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        )}
      </div>
    )}
  </div>
);

// ─── MP4 Card ──────────────────────────────────────────────────────────────────
const Mp4VideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
  const navigate = useNavigate();
  const [phase, setPhase] = useState("idle");
  const [isAdded, setIsAdded] = useState(initAdded);
  const [cartLoading, setCartLoading] = useState(false);
  const [buyLoading, setBuyLoading] = useState(false);
  const videoRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

  const handlePlay = () => setPhase("playing");

  useEffect(() => {
    if (phase !== "playing") return;
    const vid = videoRef.current;
    if (!vid || isPurchased) return;
    const onPlay = () => {
      timerRef.current = setTimeout(() => {
        vid.pause();
        setPhase("locked");
      }, FREE_SECONDS * 1000);
    };
    vid.addEventListener("play", onPlay);
    return () => {
      vid.removeEventListener("play", onPlay);
      clearTimeout(timerRef.current);
    };
  }, [phase, isPurchased]);

  const handleReplay = () => { clearTimeout(timerRef.current); setPhase("idle"); };

  const handleAddedChange = (val) => {
    setIsAdded(val);
    if (onCartChange) onCartChange(video.prod_id, val);
  };

  const handleCartClick = async () => {
    if (isAdded) return;
    setCartLoading(true);
    await addToCartApi(
      video.prod_id,
      () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  // ✅ UPDATED: video object pass karo
  const handleBuyNow = async () => {
    setBuyLoading(true);
    await buyNowApi(video, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
  };

  return (
    <div className="course-card">
      <div className="video-area">
        {isPurchased
          ? <span className="badge badge-purchased">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
              Purchased
            </span>
          : <span className="badge badge-preview">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
              {FREE_SECONDS}s Free Preview
            </span>
        }

        {phase === "idle" && (
          <>
            <video
              src={`${video.embedUrl}#t=0.5`}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              preload="metadata" muted playsInline
            />
            <div className="play-overlay">
              <button className="play-btn" onClick={handlePlay}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                  <polygon points="5,3 19,12 5,21" />
                </svg>
              </button>
            </div>
          </>
        )}

        {(phase === "playing" || phase === "locked") && (
          <>
            <video
              ref={videoRef}
              src={video.embedUrl}
              controls={isPurchased}
              autoPlay playsInline
              onError={() => setPhase("error")}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            {phase === "locked" && (
              <LockOverlay
                onReplay={handleReplay}
                prod_id={video.prod_id}
                isAdded={isAdded}
                onAddedChange={handleAddedChange}
                navigate={navigate}
              />
            )}
          </>
        )}

        {phase === "error" && <VideoErrorFallback onRetry={() => setPhase("idle")} />}
      </div>

      <CardBody
        video={video}
        isPurchased={isPurchased}
        isAdded={isAdded}
        cartLoading={cartLoading}
        buyLoading={buyLoading}
        onWatch={handlePlay}
        onCart={handleCartClick}
        onBuyNow={handleBuyNow}
        onNavigate={onNavigate}
      />
    </div>
  );
};

// ─── YouTube Card ──────────────────────────────────────────────────────────────
const YoutubeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
  const navigate = useNavigate();
  const [phase, setPhase] = useState("thumbnail");
  const [isAdded, setIsAdded] = useState(initAdded);
  const [cartLoading, setCartLoading] = useState(false);
  const [buyLoading, setBuyLoading] = useState(false);
  const timerRef = useRef(null);
  const playerRef = useRef(null);
  const divId = `yt-player-${video.prod_id}`;
  const videoId = getYouTubeId(video.embedUrl);
  const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;

  useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

  const handlePlay = async () => {
    setPhase("playing");
    await loadYouTubeAPI();
    setTimeout(() => {
      playerRef.current = new window.YT.Player(divId, {
        events: {
          onReady: (e) => {
            e.target.playVideo();
            if (!isPurchased) {
              timerRef.current = setTimeout(() => {
                e.target.pauseVideo();
                setPhase("locked");
              }, FREE_SECONDS * 1000);
            }
          },
        },
      });
    }, 300);
  };

  const handleReplay = () => {
    clearTimeout(timerRef.current);
    if (playerRef.current) {
      try { playerRef.current.destroy(); } catch (e) {}
      playerRef.current = null;
    }
    setPhase("thumbnail");
  };

  useEffect(() => () => {
    clearTimeout(timerRef.current);
    if (playerRef.current) {
      try { playerRef.current.destroy(); } catch (e) {}
    }
  }, []);

  const handleAddedChange = (val) => {
    setIsAdded(val);
    if (onCartChange) onCartChange(video.prod_id, val);
  };

  const handleCartClick = async () => {
    if (isAdded) return;
    setCartLoading(true);
    await addToCartApi(
      video.prod_id,
      () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  // ✅ UPDATED: video object pass karo
  const handleBuyNow = async () => {
    setBuyLoading(true);
    await buyNowApi(video, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
  };

  return (
    <div className="course-card">
      <div className="video-area">
        {isPurchased
          ? <span className="badge badge-purchased">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
              Purchased
            </span>
          : <span className="badge badge-preview">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
              {FREE_SECONDS}s Free Preview
            </span>
        }

        {phase === "thumbnail" && (
          <>
            {thumbUrl
              ? <img src={thumbUrl} alt={video.heading}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              : <div style={{ width: "100%", height: "100%", background: "#0d1117" }} />
            }
            <div className="play-overlay">
              <button className="play-btn" onClick={handlePlay}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                  <polygon points="5,3 19,12 5,21" />
                </svg>
              </button>
            </div>
          </>
        )}

        {(phase === "playing" || phase === "locked") && (
          <>
            <iframe
              id={divId}
              src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
              title={video.heading}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ width: "100%", height: "100%", border: "none" }}
            />
            {phase === "locked" && (
              <LockOverlay
                onReplay={handleReplay}
                prod_id={video.prod_id}
                isAdded={isAdded}
                onAddedChange={handleAddedChange}
                navigate={navigate}
              />
            )}
          </>
        )}
      </div>

      <CardBody
        video={video}
        isPurchased={isPurchased}
        isAdded={isAdded}
        cartLoading={cartLoading}
        buyLoading={buyLoading}
        onWatch={handlePlay}
        onCart={handleCartClick}
        onBuyNow={handleBuyNow}
        onNavigate={onNavigate}
      />
    </div>
  );
};

// ─── IFrame Card ───────────────────────────────────────────────────────────────
const IframeVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
  const navigate = useNavigate();
  const [phase, setPhase] = useState("thumbnail");
  const [isAdded, setIsAdded] = useState(initAdded);
  const [cartLoading, setCartLoading] = useState(false);
  const [buyLoading, setBuyLoading] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

  const handlePlay = () => {
    setPhase("playing");
    if (!isPurchased) {
      timerRef.current = setTimeout(() => setPhase("locked"), FREE_SECONDS * 1000);
    }
  };

  const handleReplay = () => { clearTimeout(timerRef.current); setPhase("thumbnail"); };
  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleAddedChange = (val) => {
    setIsAdded(val);
    if (onCartChange) onCartChange(video.prod_id, val);
  };

  const handleCartClick = async () => {
    if (isAdded) return;
    setCartLoading(true);
    await addToCartApi(
      video.prod_id,
      () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  // ✅ UPDATED: video object pass karo
  const handleBuyNow = async () => {
    setBuyLoading(true);
    await buyNowApi(video, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
  };

  const iframeSrc = video.embedUrl.includes("vimeo")
    ? buildVimeoEmbedUrl(video.embedUrl)
    : video.embedUrl;

  return (
    <div className="course-card">
      <div className="video-area">
        {isPurchased
          ? <span className="badge badge-purchased">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
              Purchased
            </span>
          : <span className="badge badge-preview">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
              {FREE_SECONDS}s Free Preview
            </span>
        }

        {phase === "thumbnail" && (
          <div className="play-overlay" style={{ background: "rgba(0,0,0,0.55)" }}>
            <button className="play-btn" onClick={handlePlay}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <polygon points="5,3 19,12 5,21" />
              </svg>
            </button>
          </div>
        )}

        {(phase === "playing" || phase === "locked") && (
          <>
            <iframe
              src={iframeSrc}
              title={video.heading}
              allow="autoplay; fullscreen"
              allowFullScreen
              style={{ width: "100%", height: "100%", border: "none" }}
            />
            {phase === "locked" && (
              <LockOverlay
                onReplay={handleReplay}
                prod_id={video.prod_id}
                isAdded={isAdded}
                onAddedChange={handleAddedChange}
                navigate={navigate}
              />
            )}
          </>
        )}
      </div>

      <CardBody
        video={video}
        isPurchased={isPurchased}
        isAdded={isAdded}
        cartLoading={cartLoading}
        buyLoading={buyLoading}
        onWatch={handlePlay}
        onCart={handleCartClick}
        onBuyNow={handleBuyNow}
        onNavigate={onNavigate}
      />
    </div>
  );
};

// ─── No Video Card ─────────────────────────────────────────────────────────────
const NoVideoCard = ({ video, isPurchased, isAdded: initAdded, onCartChange, onNavigate }) => {
  const navigate = useNavigate();
  const [isAdded, setIsAdded] = useState(initAdded);
  const [cartLoading, setCartLoading] = useState(false);
  const [buyLoading, setBuyLoading] = useState(false);

  useEffect(() => { setIsAdded(initAdded); }, [initAdded]);

  const handleCartClick = async () => {
    if (isAdded) return;
    setCartLoading(true);
    await addToCartApi(
      video.prod_id,
      () => { setIsAdded(true); if (onCartChange) onCartChange(video.prod_id, true); setCartLoading(false); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  // ✅ UPDATED: video object pass karo
  const handleBuyNow = async () => {
    setBuyLoading(true);
    await buyNowApi(video, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
  };

  return (
    <div className="course-card">
      <div className="video-area">
        {isPurchased && (
          <span className="badge badge-purchased">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Purchased
          </span>
        )}
        <NoVideoPlaceholder />
      </div>

      <CardBody
        video={video}
        isPurchased={isPurchased}
        isAdded={isAdded}
        cartLoading={cartLoading}
        buyLoading={buyLoading}
        onWatch={null}
        onCart={handleCartClick}
        onBuyNow={handleBuyNow}
        onNavigate={onNavigate}
      />
    </div>
  );
};

// ─── MAIN COMPONENT ────────────────────────────────────────────────────────────
const CourseSection3 = () => {
  const { setCartCount } = useCart();
  const navigate = useNavigate();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [purchasedProdIds, setPurchasedProdIds] = useState(new Set());
  const [cartProdIds, setCartProdIds] = useState(new Set());
  const [seoData, setSeoData] = useState({});
useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}index.php/Api/get_seo_by_page`, {
        page_name: 'courses'   // <-- Important! page_name 'ebooks' rakho
      });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  // ── Load products ──
  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(API_URL);
        if (!res.data?.status) { setError("No products found"); return; }

        const products = Array.isArray(res.data.products) ? res.data.products : [];

        const list = products
          .filter((p) => p.product_type && p.product_type.toLowerCase() === "coursesection")
          .map((p) => {
            let rawUrl = p.video || p.video_url || p.product_video || "";
            if (rawUrl && !rawUrl.startsWith("http")) rawUrl = BASE_URL + rawUrl;
            const type = detectVideoType(rawUrl);
            let embedUrl = rawUrl;
            if (type === "youtube") embedUrl = buildYouTubeEmbedUrl(rawUrl);
            return {
              id: p.id || p.ref_id,
              prod_id: p.prod_id,
              heading: p.heading || p.product_name || p.title || "Untitled Course",
              description: p.description || "",
              details: p.details || "",
              current_price: p.current_price || 0,
              old_price: p.old_price || 0,
              embedUrl,
              type,
            };
          });

        setVideos(list);
      } catch (e) {
        console.error("API Error:", e);
        setError("Failed to fetch products");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // ── Load cart & purchased state ──
  useEffect(() => {
    const init = async () => {
      const userId = sessionStorage.getItem("userId");
      const cartToken = localStorage.getItem("cart_token");

      if (userId || cartToken) {
        try {
          const res = await axios.post(
            "https://ecom.cyberathon.com/index.php/Api/list_cart",
            {
              user_id: userId || null,
              cart_token: userId ? null : cartToken,
            }
          );
          if (res.data.status) {
            setCartProdIds(
              new Set(res.data.cart_items.map((i) => String(i.prod_id)))
            );
          }
        } catch (e) { console.error(e); }
      }

      if (userId) {
        try {
          const res = await axios.post(
            "https://ecom.cyberathon.com/index.php/Api/list_new_order",
            { user_id: parseInt(userId) }
          );
          if (res.data.status && Array.isArray(res.data.orders)) {
            const ids = new Set();
            res.data.orders.forEach((order) => {
              if (!Array.isArray(order.items)) return;
              order.items.forEach((item) => {
                if (!item.prod_id) return;
                if (
                  item.access === "unlocked" ||
                  order.purchase_status === "yes" ||
                  order.payment_status === "Paid" ||
                  order.payment_status === "paid" ||
                  order.order_status === "Delivered" ||
                  order.order_status === "Completed"
                ) {
                  ids.add(String(item.prod_id));
                }
              });
            });
            setPurchasedProdIds(ids);
          }
        } catch (e) { console.error(e); }
      }
    };
    init();

    const onLogin = () => init();
    window.addEventListener("userLoggedIn", onLogin);
    return () => window.removeEventListener("userLoggedIn", onLogin);
  }, []);

  const handleCartChange = (prod_id, added) => {
    setCartProdIds((prev) => {
      const next = new Set(prev);
      if (added) {
        if (!next.has(String(prod_id))) {
          next.add(String(prod_id));
          setCartCount((c) => c + 1);
        }
      } else {
        if (next.has(String(prod_id))) {
          next.delete(String(prod_id));
          setCartCount((c) => Math.max(0, c - 1));
        }
      }
      return next;
    });
  };

  const renderCard = (v) => {
    const strId = String(v.prod_id);
    const isPurchased = purchasedProdIds.has(strId);
    const isAdded = cartProdIds.has(strId);
    const props = {
      key: v.prod_id,
      video: v,
      isPurchased,
      isAdded,
      onCartChange: handleCartChange,
      onNavigate: () => navigate(`/coursesectiondetail/${v.prod_id}`),
    };

    switch (v.type) {
      case "youtube":  return <YoutubeVideoCard {...props} />;
      case "mp4":      return <Mp4VideoCard {...props} />;
      case "iframe":   return <IframeVideoCard {...props} />;
      case "no-video": return <NoVideoCard {...props} />;
      default:         return <Mp4VideoCard {...props} />;
    }
  };

  return (
    <>
     <SEO
        title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
        description={seoData.description || "Explore our wide collection of E-Books on programming, design, and more."}
        keywords={seoData.keywords || "ebooks, shopindia, buy ebooks, online books, programming ebooks, design ebooks"}
        canonical={seoData.canonical || "https://www.shopindia.com/ebooks"}
      />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

        :root {
          --teal: #0ecfce;
          --teal-dark: #0ab5b4;
          --green: #22c55e;
          --green-dark: #16a34a;
          --amber: #f59e0b;
          --amber-dark: #d97706;
          --card-bg: #ffffff;
          --card-border: #e5f0f0;
          --card-hover-border: #0ecfce;
          --text-primary: #0f172a;
          --text-secondary: #475569;
          --text-muted: #94a3b8;
          --surface: #f7fffe;
        }

        .cs-root {
          background: var(--surface);
          min-height: 60vh;
          padding: 64px 0 80px;
          font-family: 'DM Sans', sans-serif;
        }

        .cs-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
          gap: 24px;
          padding: 0 24px;
          max-width: 1240px;
          margin: 0 auto;
        }

        .course-card {
          background: var(--card-bg);
          border: 1.5px solid var(--card-border);
          border-radius: 20px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          transition: transform 0.28s cubic-bezier(.22,.68,0,1.2),
                      box-shadow 0.28s ease,
                      border-color 0.2s ease;
          animation: csCardIn 0.45s ease both;
          position: relative;
        }
        .course-card:hover {
          transform: translateY(-7px);
          box-shadow: 0 20px 52px rgba(14,207,206,0.12), 0 4px 16px rgba(0,0,0,0.05);
          border-color: var(--card-hover-border);
        }
        @keyframes csCardIn {
          from { opacity: 0; transform: translateY(22px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .video-area {
          position: relative;
          width: 100%;
          height: 205px;
          background: #0d1117;
          overflow: hidden;
          flex-shrink: 0;
        }
        .video-area img,
        .video-area video,
        .video-area iframe {
          width: 100%; height: 100%; object-fit: cover; display: block;
        }

        .no-video-placeholder {
          width: 100%; height: 100%;
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          gap: 10px; background: #0d1117;
        }
        .no-video-placeholder span {
          font-size: 12px; color: rgba(255,255,255,0.2);
          font-family: 'DM Sans', sans-serif;
        }

        .video-error-fallback {
          width: 100%; height: 100%;
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          gap: 10px; background: #0d1117;
          padding: 20px; text-align: center;
        }
        .video-error-fallback span {
          font-size: 12px; color: rgba(255,255,255,0.25);
          font-family: 'DM Sans', sans-serif;
        }
        .btn-retry {
          background: rgba(14,207,206,0.12); color: var(--teal);
          border: 1px solid rgba(14,207,206,0.3); border-radius: 8px;
          padding: 5px 14px; font-size: 11.5px; font-weight: 600;
          cursor: pointer; font-family: 'DM Sans', sans-serif;
          transition: background 0.2s;
        }
        .btn-retry:hover { background: rgba(14,207,206,0.2); }

        .play-overlay {
          position: absolute; inset: 0;
          background: rgba(0,0,0,0.28);
          display: flex; align-items: center; justify-content: center;
          z-index: 4; transition: background 0.2s; cursor: pointer;
        }
        .play-overlay:hover { background: rgba(0,0,0,0.4); }
        .play-btn {
          width: 56px; height: 56px; border-radius: 50%;
          background: var(--teal); border: 3px solid rgba(255,255,255,0.25);
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s;
          box-shadow: 0 4px 24px rgba(14,207,206,0.4);
        }
        .play-btn:hover { transform: scale(1.12); background: var(--teal-dark); }
        .play-btn svg { margin-left: 3px; }

        .badge {
          position: absolute; top: 12px; left: 12px;
          display: inline-flex; align-items: center; gap: 5px;
          font-size: 11px; font-weight: 700; padding: 4px 6px;
          border-radius: 100px; z-index: 5; letter-spacing: 0.2px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          backdrop-filter: blur(8px);
        }
        .badge-preview {
          background: rgba(14,207,206,0.18); color: #fff;
          border: 1px solid rgba(14,207,206,0.4);
        }
        .badge-purchased {
          background: rgba(34,197,94,0.18); color: #fff;
          border: 1px solid rgba(34,197,94,0.4);
        }

        .lock-overlay {
          position: absolute; inset: 0;
          background: rgba(8,12,20,0.93); backdrop-filter: blur(6px);
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          z-index: 10; padding: 24px 20px; text-align: center; gap: 9px;
          animation: csLockIn 0.22s ease;
        }
        @keyframes csLockIn {
          from { opacity: 0; transform: scale(0.97); }
          to   { opacity: 1; transform: scale(1); }
        }
        .lock-pulse-ring {
          position: absolute; width: 90px; height: 90px; border-radius: 50%;
          border: 1.5px solid rgba(14,207,206,0.22);
          animation: lockPulse 2s ease-in-out infinite;
          pointer-events: none;
        }
        @keyframes lockPulse {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.35); opacity: 0; }
        }
        .lock-icon-wrap {
          width: 58px; height: 58px; border-radius: 50%;
          background: rgba(14,207,206,0.1); border: 1.5px solid rgba(14,207,206,0.3);
          display: flex; align-items: center; justify-content: center;
          position: relative; z-index: 1;
        }
        .lock-title {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 15px; font-weight: 800; color: #f1f5f9; margin: 2px 0 0;
        }
        .lock-sub {
          font-size: 12px; color: #64748b; margin: 0;
          line-height: 1.55; max-width: 200px;
        }

        .lock-action-row {
          display: flex; gap: 8px; width: 100%; max-width: 220px;
        }
        .btn-lock-cart {
          flex: 1; background: var(--teal); color: #fff;
          border: none; border-radius: 10px;
          padding: 9px 10px; font-size: 12px; font-weight: 700; cursor: pointer;
          display: flex; align-items: center; justify-content: center; gap: 5px;
          transition: opacity 0.2s, transform 0.15s;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .btn-lock-cart:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
        .btn-lock-cart.added { background: #24aeb1; cursor: default; }
        .btn-lock-cart:disabled { opacity: 0.7; }

        .btn-lock-buy {
          flex: 1; background:#24aeb1; color: #fff;
          border: none; border-radius: 10px;
          padding: 9px 10px; font-size: 12px; font-weight: 700; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: opacity 0.2s, transform 0.15s;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .btn-lock-buy:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); }
        .btn-lock-buy:disabled { opacity: 0.7; cursor: not-allowed; }

        .btn-replay {
          background: transparent; color: #475569;
          border: 1px solid #2d3748; border-radius: 8px;
          padding: 6px 14px; font-size: 11.5px; font-weight: 600;
          cursor: pointer; display: flex; align-items: center; gap: 5px;
          transition: color 0.2s, border-color 0.2s;
          font-family: 'DM Sans', sans-serif;
        }
        .btn-replay:hover { color: #94a3b8; border-color: #475569; }

        .card-body-inner {
          padding: 18px 20px 20px;
          display: flex; flex-direction: column;
          flex: 1; gap: 10px;
        }
        .card-title {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 15.5px; font-weight: 700; color: var(--text-primary);
          margin: 0; line-height: 1.4; letter-spacing: -0.2px;
          transition: color 0.15s;
        }
        .card-title:hover { color: var(--teal); }

        .html-content ul, .html-content ol { padding-left: 20px; margin: 4px 0; }
        .html-content ul li, .html-content ol li {
          color: var(--text-secondary); font-size: 13px;
          margin-bottom: 3px; line-height: 1.6; list-style-type: disc;
        }
        .html-content ol li { list-style-type: decimal; }
        .html-content p { margin: 0 0 4px; color: var(--text-secondary); font-size: 13px; line-height: 1.65; }
        .html-content strong { color: var(--text-primary); }
        .html-content a { color: var(--teal); text-decoration: none; }
        .card-desc { font-size: 13px; color: var(--text-secondary); line-height: 1.65; }

        .price-row { display: flex; align-items: baseline; gap: 10px; margin-top: 2px; }
        .price-current {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 21px; font-weight: 800;
          color: var(--green); letter-spacing: -0.5px;
        }
        .price-old {
          font-size: 13.5px; color: var(--text-muted);
          text-decoration: line-through; font-weight: 500;
        }
        .price-free {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 16px; font-weight: 700; color: var(--teal);
        }

        .no-prod-tag {
          display: inline-flex; align-items: center; gap: 5px;
          color: var(--text-muted); font-size: 12px; font-weight: 500;
          padding: 8px 12px; border-radius: 8px;
          background: #f8fafc; border: 1px dashed #e2e8f0;
          font-family: 'DM Sans', sans-serif; margin-top: auto;
        }

        .btn-stack {
          display: flex; flex-direction: column;
          gap: 8px; margin-top: auto;
        }

        .course-action-row {
          display: flex; gap: 8px;
        }

        .btn-cart {
          flex: 1;
          padding: 11px 0; border-radius: 12px;
          border: 1.5px solid var(--teal);
          font-size: 13px; font-weight: 700;
          cursor: pointer; background: linear-gradient(135deg, #24aeb1, #058587); color: white;
          display: flex; align-items: center; justify-content: center;
          gap: 6px; letter-spacing: 0.1px;
          transition: background 0.2s, color 0.2s, transform 0.15s;
          font-family: 'Plus Jakarta Sans', sans-serif;
          min-width: 0;
        }
        .btn-cart:hover:not(:disabled):not(.added) {
          background: #24aeb1; color: #fff; transform: translateY(-1px);
        }
        .btn-cart.added {
          background: #24aeb1; border-color: #24aeb1;
          color: white; cursor: default;
        }
        .btn-cart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

        .btn-buy-now {
          flex: 1;
          padding: 11px 0; border-radius: 12px;
          border: none;
          font-size: 13px; font-weight: 700;
          cursor: pointer;
          background: linear-gradient(135deg, #24aeb1, #058587);
          color: #fff;
          display: flex; align-items: center; justify-content: center;
          gap: 6px;
          transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
          font-family: 'Plus Jakarta Sans', sans-serif;
          box-shadow: 0 2px 12px rgba(19, 170, 176, 0.3);
          min-width: 0;
        }
        .btn-buy-now:hover:not(:disabled) {
          opacity: 0.92; transform: translateY(-1px);
          box-shadow: 0 4px 18px rgba(10, 179, 182, 0.4);
        }
        .btn-buy-now:disabled { opacity: 0.65; cursor: not-allowed; }

        .btn-watch {
          padding: 12px 0; border-radius: 12px; border: none;
          font-size: 13.5px; font-weight: 700; cursor: pointer;
          background: linear-gradient(135deg, #22c55e, #16a34a); color: #fff;
          width: 100%; display: flex; align-items: center; justify-content: center;
          gap: 7px; transition: opacity 0.2s, transform 0.15s;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .btn-watch:hover { opacity: 0.9; transform: translateY(-1px); }

        .btn-view-details {
          padding: 9px 0; border-radius: 10px;
          border: 1px solid #24aeb1;
          font-size: 13px; font-weight: 600;
          cursor: pointer; background: #f8fffe; color: var(--teal);
          width: 100%; display: flex; align-items: center; justify-content: center;
          gap: 5px; transition: background 0.2s, border-color 0.2s;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .btn-view-details:hover {
          background: rgba(14,207,206,0.06); border-color: var(--teal);
        }

        .cs-spinner {
          display: inline-block; width: 15px; height: 15px;
          border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
          border-radius: 50%; animation: csSpin 0.7s linear infinite;
        }
        .cs-spinner-dark {
          border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
        }
        @keyframes csSpin { to { transform: rotate(360deg); } }

        .cs-skeleton-card {
          background: white; border-radius: 20px;
          overflow: hidden; border: 1.5px solid #f1f5f9;
        }
        .cs-skeleton {
          background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%);
          background-size: 200% 100%;
          animation: csSkeleton 1.5s ease-in-out infinite;
          border-radius: 6px;
        }
        @keyframes csSkeleton {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }

        @media (max-width: 600px) {
          .cs-grid { padding: 0 12px; gap: 16px; }
          .course-action-row { flex-direction: column; gap: 8px; }
          .btn-cart, .btn-buy-now { flex: none; width: 100%; }
        }
      `}</style>

      <div className="cs-root">
        <div className="container-fluid px-0">
          <h1 className="text-center fw-bold text-bold pb-5">Our Courses</h1>

          {loading && (
            <div className="cs-grid">
              {[1, 2, 3].map((n) => (
                <div key={n} className="cs-skeleton-card">
                  <div className="cs-skeleton" style={{ height: 205, borderRadius: 0 }} />
                  <div style={{ padding: "18px 20px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
                    <div className="cs-skeleton" style={{ height: 18, width: "85%" }} />
                    <div className="cs-skeleton" style={{ height: 13, width: "70%" }} />
                    <div className="cs-skeleton" style={{ height: 13, width: "55%" }} />
                    <div className="cs-skeleton" style={{ height: 28, width: "40%", marginTop: 4 }} />
                    <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                      <div className="cs-skeleton" style={{ height: 44, flex: 1, borderRadius: 12 }} />
                      <div className="cs-skeleton" style={{ height: 44, flex: 1, borderRadius: 12 }} />
                    </div>
                    <div className="cs-skeleton" style={{ height: 38, borderRadius: 10 }} />
                  </div>
                </div>
              ))}
            </div>
          )}

          {error && (
            <p style={{ textAlign: "center", color: "#ef4444", padding: 40 }}>{error}</p>
          )}

          {!loading && !error && videos.length === 0 && (
            <p style={{ textAlign: "center", color: "#94a3b8", padding: 40 }}>No courses found.</p>
          )}

          {!loading && !error && (
            <div className="cs-grid">
              {videos.map((v) => renderCard(v))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CourseSection3;
